<template>
  <i
    :class="className"
    v-on="$listeners"
  />
</template>

<script>

/*
 * Icon component opinionated to support the fontawesome icons
 */
const fontAwesomeVariants = {
  regular: 'far',
  solid: 'fas',
  light: 'fal',
  duotone: 'fad',
  brands: 'fab'
}

export default {
  name: 'Icon',

  props: {
    variant: {
      type: String,
      default: 'regular'   
    },

    name: {
      type: String,
      required: true
    },

    size: {
      type: String,
      default: 'medium'
    }
  },

  computed: {
    className () {
      const variantClass = fontAwesomeVariants[this.variant]

      const iconClass = `fa-${this.name}`

      return [
        variantClass,
        iconClass,
        this.$style.root,
        this.$style[this.size]
      ]
    }
  }
}

</script>

<style module>

.root {}

.small {
  @apply text-xs;
}

.medium {
  @apply text-base;
}

.large {
  @apply text-lg;
}

.extra-large {
  @apply text-xl;
}

.extra-large2x {
  @apply text-2xl;
}

.extra-large3x {
  @apply text-3xl;
}

</style>
